import Box from '@mui/material/Box';
import Fab from '@mui/material/Fab';
import AddIcon from '@mui/icons-material/Add';
import RemoveIcon from '@mui/icons-material/Remove';
import IconButton from '@mui/material/IconButton';
import CenterFocusStrongIcon from '@mui/icons-material/CenterFocusStrong';
import PersonSearchIcon from '@mui/icons-material/PersonSearch';
import FileDownloadIcon from '@mui/icons-material/FileDownload';
import DownloadForOfflineIcon from '@mui/icons-material/DownloadForOffline';
import FitScreenIcon from '@mui/icons-material/FitScreen';
import RestoreIcon from '@mui/icons-material/Restore';
import Tooltip from '@mui/material/Tooltip';
import { fitEdges } from '../../../utils/treeGraph';

export const Navigation = ({
  zoomIn,
  zoomOut,
  resetTransform,
  setTransform,
  drawingWidth,
  drawingHeight,
  treeBounds,
  resetRootId,
  resetRootHandler,
  openSearchModal,
  handleDownload,
  handleGedcomExport,
}: any) => {
  return (
    <Box
      sx={{
        position: 'absolute',
        top: '16px',
        left: '10px',
        zIndex: 20,
        display: 'flex',
        flexDirection: 'column',
        gap: 1,
        '@media print': {
          display: 'none',
        },
      }}
    >
      {resetRootId && (
        <Fab
          size="small"
          color="primary"
          aria-label="Reset to root user"
          component="div"
        >
          <Tooltip title="Reset to root user" placement="right">
            <IconButton onClick={resetRootHandler}>
              <RestoreIcon color="secondary" />
            </IconButton>
          </Tooltip>
        </Fab>
      )}
      <Fab
        size="small"
        color="primary"
        aria-label="Search tree"
        component="div"
      >
        <Tooltip title="Search family tree" placement="right">
          <IconButton onClick={openSearchModal}>
            <PersonSearchIcon color="secondary" />
          </IconButton>
        </Tooltip>
      </Fab>
      <Fab
        size="small"
        color="primary"
        aria-label="Download JPG"
        component="div"
      >
        <Tooltip title="Download JPG" placement="right">
          <IconButton onClick={handleDownload}>
            <FileDownloadIcon color="secondary" />
          </IconButton>
        </Tooltip>
      </Fab>
      <Fab
        size="small"
        color="primary"
        aria-label="Download GEDCOM"
        component="div"
      >
        <Tooltip title="Download GEDCOM" placement="right">
          <IconButton onClick={handleGedcomExport}>
            <DownloadForOfflineIcon color="secondary" />
          </IconButton>
        </Tooltip>
      </Fab>
      <Fab size="small" color="primary" aria-label="Zoom in" component="div">
        <Tooltip title="Zoom in" placement="right">
          <IconButton onClick={() => zoomIn()}>
            <AddIcon color="secondary" />
          </IconButton>
        </Tooltip>
      </Fab>
      <Fab size="small" color="primary" aria-label="Zoom out" component="div">
        <Tooltip title="Zoom out" placement="right">
          <IconButton onClick={() => zoomOut()}>
            <RemoveIcon color="secondary" />
          </IconButton>
        </Tooltip>
      </Fab>
      <Fab
        size="small"
        color="primary"
        aria-label="Center tree"
        component="div"
      >
        <Tooltip title="Center tree" placement="right">
          <IconButton onClick={() => resetTransform()}>
            <CenterFocusStrongIcon color="secondary" />
          </IconButton>
        </Tooltip>
      </Fab>
      <FitScreen
        setTransform={setTransform}
        drawingHeight={drawingHeight}
        drawingWidth={drawingWidth}
        treeBounds={treeBounds}
      />
    </Box>
  );
};

function FitScreen({
  setTransform,
  drawingHeight,
  drawingWidth,
  treeBounds,
}: any) {
  const onFitTreeHandle = () => {
    fitEdges({
      drawingWidth,
      drawingHeight,
      bounds: treeBounds,
      setTransform,
    });
  };
  return (
    <Fab
      size="small"
      color="primary"
      aria-label="Fit tree to screen"
      component="div"
    >
      <Tooltip title="Fit tree to screen" placement="right">
        <IconButton onClick={onFitTreeHandle}>
          <FitScreenIcon color="secondary" />
        </IconButton>
      </Tooltip>
    </Fab>
  );
}
